import { render } from "./SwissMap.vue?vue&type=template&id=6deca4b8&scoped=true"
const script = {}

import "./SwissMap.vue?vue&type=style&index=0&id=6deca4b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6deca4b8"

export default script